import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import type { TypeGetInboundRequestProgressRequestIdResponse } from '~/types/receive.types';

type TypeFetchInboundRequestProgressByRequestIdParams = {
  ownerCode: string;
  requestId: string;
};

const fetchInboundRequestProgressByRequestId = async ({
  ownerCode,
  requestId,
}: TypeFetchInboundRequestProgressByRequestIdParams): Promise<TypeGetInboundRequestProgressRequestIdResponse> => {
  const { data } = await axiosInstance.get<TypeGetInboundRequestProgressRequestIdResponse>(
    `/api-inbound/v1/3pl/receiving/${ownerCode}/inbound-request/progress/${requestId}`
  );
  return data;
};

/**
 * [입고관리 > 입고현황] 3PL 입고현황 상세 조회 Mutation Hook
 */
export const useGetInboundRequestProgressByRequestIdMutation = () => {
  return useMutation({
    mutationFn: fetchInboundRequestProgressByRequestId,
  });
};
